import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-none px-8 py-4 text-sm font-medium uppercase tracking-[0.12em] transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ink focus-visible:ring-offset-cream";

const variants = {
  primary: "bg-terracotta text-espresso hover:bg-terracotta-dark",
  outline: "border border-ink bg-transparent text-ink hover:bg-ink hover:text-cream",
  cream: "border border-cream bg-transparent text-cream hover:bg-cream hover:text-ink",
  espresso: "border border-espresso bg-transparent text-espresso hover:bg-espresso hover:text-cream",
};

export const Button = ({ variant = "primary", className = "", children, ...props }) => (
  <button className={`${base} ${variants[variant]} ${className}`} {...props}>
    {children}
  </button>
);

export const LinkButton = ({ to, variant = "outline", className = "", children, ...props }) => (
  <Link to={to} className={`${base} ${variants[variant]} ${className}`} {...props}>
    {children}
  </Link>
);

// The "Book Now" button. TRYBE not wired yet — clicking just notes it.
export const BookButton = ({ variant = "primary", className = "", label = "Book Now" }) => (
  <Button
    variant={variant}
    className={className}
    data-testid="book-now-button"
    onClick={() =>
      toast("Booking opens soon", {
        description: "Reservations will be available before the December opening.",
      })
    }
  >
    {label}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Button>
);
